export default __webpack_public_path__ + "static/media/img-0502-holy-see-half-face.02fa89ea.png";